import axios from "../api/axios";

// ✅ ВАЖНО: теперь prefix backoffice
export const getUserReviews = (userId, page = 1) =>
  axios.get(`/backoffice/users/${userId}/reviews?page=${page}`);

export const upsertUserReview = (userId, payload) =>
  axios.put(`/backoffice/users/${userId}/reviews`, payload);

export const deleteMyReviewForUser = (userId) =>
  axios.delete(`/backoffice/users/${userId}/reviews`);

export const setReviewVisibility = (reviewId, visible) =>
  axios.patch(`/backoffice/reviews/${reviewId}/visibility`, { visible });
// ⚠️ если у тебя patch реально без /backoffice (редко), поменяешь.
// Но чаще он в том же prefix.
